import { useState } from "react";
import dayjs from "dayjs";
import { Calendar as CalendarIcon } from "lucide-react";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import { CalendarPanel } from "./CalendarPanel";

export const DeliveryDatePicker = ({ value, onChange, openUpward = true, disabled = false }) => {
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);

    const commit = (date) => {
        onChange(dayjs(date).format("YYYY-MM-DD"));
    };

    return (
        <div className="relative w-full">
            <button
                type="button"
                disabled={disabled}
                onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                className="w-full flex items-center justify-between bg-cm-p-surface-container rounded-[6px] px-3 h-[40px] gap-2 border border-cm-p-outline disabled:cursor-not-allowed disabled:opacity-40"
            >
                <span className={`text-[15px] font-medium ${value ? "text-cm-p-text-primary" : "text-cm-p-text-secondary"}`}>
                    {value ? dayjs(value).format("MMM D 'YY") : "Select date"}
                </span>
                <CalendarIcon className="w-4 h-4 text-cm-p-text-secondary shrink-0" />
            </button>
            {!disabled && isCalendarOpen && (
                <ClickAwayListener onClickAway={() => setIsCalendarOpen(false)}>
                    <div
                        className={`absolute right-0 z-modal-dropdown w-[300px] rounded-xl bg-cm-p-surface border border-cm-p-outline drop-shadow-[0_2px_4px_rgba(33,33,33,0.12)] ${
                            openUpward ? "bottom-[44px]" : "top-[44px]"
                        }`}
                    >
                        <CalendarPanel
                            value={value ? dayjs(value).toDate() : undefined}
                            onChange={commit}
                            minDate={new Date()}
                            onToday={() => {
                                commit(dayjs());
                                setIsCalendarOpen(false);
                            }}
                            onApply={() => setIsCalendarOpen(false)}
                        />
                    </div>
                </ClickAwayListener>
            )}
        </div>
    );
};
